<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import type { Payment, StageSetup } from '@/types'

import UiHeader from '@/components/UiHeader/UiHeader.vue'
import UiStatusCard from '@/components/UiStatusCard/UiStatusCard.vue'
import UiTable from '@/components/UiTable/UiTable.vue'
import UiFooter from '@/components/UiFooter/UiFooter.vue'
import AppHeader from '@/layouts/AppHeader/AppHeader.vue'

const route = useRoute()
const payment = ref<Payment>()
const orderNumber = ref<string>()

const isLoaded = ref<boolean>(false)

const stage: StageSetup = {
  title: 'Не удалось оплатить',
  subtitle: 'Попробуйте воспользоваться другим способом оплаты',
  description: 'Нажмите на кнопку ниже для возврата к выбору платежных инструментов',
  icon: 'https://storage.yandexcloud.net/terpay/error-icon.png',
  color: '#FFDBDB'
}

async function getPayment(uuid: string) {
  await axios.get(`/payments/${uuid}`).then((response: { data: Payment }) => {
    payment.value = response.data
    orderNumber.value = uuid
  })
}

onMounted(async () => {
  const orderNumber = `${route.query.order_number || ''}`
  if (orderNumber) {
    await getPayment(orderNumber)
  }
  isLoaded.value = true
})
</script>

<template>
  <div v-if="isLoaded" class="payment-cabinet">
    <div class="">
      <app-header />

      <ui-status-card :stage="stage" />

      <ui-table
        v-if="payment"
        :order-number="orderNumber"
        :date="payment.status_change_at"
        :provider-title="`${payment.provider.title} ${
          payment.action.title ? `(${payment.action.title})` : ''
        }`"
        :provider-type="payment.provider.type"
        :total-price="payment.sum"
        :return-url="payment.return_url"
        :stage-code="'Error'"
        :stage="stage"
      />

      <ui-footer />
    </div>
  </div>
</template>

<style lang="scss">
</style>
